import { Suspense, useEffect } from 'react';
import './lib/bootstrap.css';

import { useLocation } from 'react-router-dom';
import { Toolbar } from './components/Toolbar/Toolbar';
import { PublicRoutes } from './routes/public.routes';
// import { isAndroid, isIOS } from 'mobile-device-detect';
import { useSelectedLanguage } from './components/Dashboard/Common/Translate/atom';
import { usePossibleUser } from './hooks/useProfile';
import { useSettings } from './hooks/useSettings';
import posthog from 'posthog-js';
import { safeLazy } from './components/SafeLazy/SafeLazy';
import { Flex, Skeleton, Stack } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { TourProvider } from '@reactour/tour';
import { accent } from './res/costants/colors';
import { trpc } from './trpc/trpc';

const Contact = safeLazy(() => import('./Contact/Contact'));

const Footer = safeLazy(() => import('./ui/Footer/Footer'));

const StatusPage = safeLazy(() => import('./pages/StatusPage/StatusPage'));

// const DownloadApp = safeLazy(() => import('./alerts/DownloadApp'));

const App = () => {
  // This is used to update the webapp language because when user switch language from
  // the toolbar selector, i18n will be updated in setLocale but will not trigger a state update.
  // The store set action will, instead, update every page in which useSelectedLanguage is used.
  useSelectedLanguage();

  const platformSettings = trpc.platformSettings.useQuery();

  const location = useLocation();

  const [, setAllCookies] = useLocalStorage({
    key: 'all-cookies',
    defaultValue: null,
    getInitialValueInEffect: false
  });

  const profile = usePossibleUser();
  const { setSettings } = useSettings();

  useEffect(() => {
    if (profile) {
      if (posthog.__loaded) {
        posthog.identify(profile._id, {
          email: profile.email,
          name: profile.firstName + ' ' + profile.lastName
        });
      }
    }
  }, [profile]);

  // const [showGoToApp, setShowGoToApp] = useState(
  //   (localStorage.getItem('downloadApp') || 'true') === 'true'
  // );

  if (
    platformSettings.data?.maintenance &&
    !location.pathname.includes('signin') &&
    profile?.role !== 'admin'
  ) {
    return (
      <Suspense>
        <StatusPage type="503" />
      </Suspense>
    );
  }

  // if (import.meta.env.VITE_BRAND === 'seedsbit' && !isApp && (isAndroid || isIOS) && showGoToApp) {
  //   return (
  //     <Suspense>
  //       <DownloadApp device={isIOS ? 'iOS' : 'Android'} onCancel={setShowGoToApp} />
  //     </Suspense>
  //   );
  // }

  const hideUI = location.pathname.startsWith('/dl/');

  return (
    <>
      <TourProvider
        steps={[]}
        disableKeyboardNavigation={['left', 'esc']}
        onClickClose={({ setIsOpen }) => {
          setIsOpen(false);
          setSettings({ mainTour: true });
        }}
        onClickMask={() => {}}
        prevButton={() => <span />}
        styles={{
          popover: (base) => ({
            ...base,
            maxWidth: 500,
            borderRadius: 16
          }),
          dot: (base) => ({
            ...base,
            background: base.border === '0' ? accent : 'rgba(0, 0, 0, 0.2)'
          })
        }}>
        <Stack id="app-stack" gap={0} mih="100dvh">
          {!hideUI && <Toolbar />}
          <Flex id="app-router" align="stretch" flex={1} pos="relative">
            <Suspense>
              <PublicRoutes />
              {!hideUI && <Contact />}
            </Suspense>
          </Flex>
        </Stack>
        {!hideUI && (
          <Suspense fallback={<Skeleton w="100%" height={250} />}>
            <Footer showCookies={() => setAllCookies(null)} />
          </Suspense>
        )}
      </TourProvider>
    </>
  );
};

export default App;
